import {ApiClient} from '@hconnect/apiclient'
import {
  EquipmentPerformanceDto,
  KpiCalculationTimeFrameDto,
  KpiVisibilityFlag
} from '@hconnect/common/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import qs from 'qs'

import {KpisQueryKey} from '../../types'

const QueryKeyPrefix = KpisQueryKey.EquipmentPerformances

type EquipmentPerformancesParams = {
  plantId: string
  kpiVisibilityFlag: KpiVisibilityFlag
  timeFrames: KpiCalculationTimeFrameDto[]
}

export const useEquipmentPerformances = <TSelect = EquipmentPerformanceDto[]>(
  {plantId, timeFrames, kpiVisibilityFlag}: EquipmentPerformancesParams,
  options?: Omit<
    UseQueryOptions<EquipmentPerformanceDto[], AxiosError, TSelect>,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery<EquipmentPerformanceDto[], AxiosError, TSelect>({
    queryKey: [QueryKeyPrefix, plantId, timeFrames, kpiVisibilityFlag],
    queryFn: async ({signal}) => {
      const payload = timeFrames
      const path = `/kpi-result/${plantId}/equipment-performances`
      const response = await ApiClient.axiosInstance.post<EquipmentPerformanceDto[]>(
        path,
        payload,
        {
          params: {kpiVisibilityFlags: [kpiVisibilityFlag]},
          paramsSerializer: (params) => qs.stringify(params, {arrayFormat: 'repeat'}),
          signal
        }
      )

      return response.data
    },
    ...options
  })
}
